import { GetOutput } from '@jwplayer/companion-gateway';
import { BrowserOptions } from '@sentry/browser';

import { promiseOnce } from '../util';

import { getSentryConfig } from './config';

export const getSentry = promiseOnce(async () => {
  const sentry = await import('@sentry/react');

  const config: BrowserOptions = {
    ...getSentryConfig(),
  };

  sentry.init(config);

  return sentry;
});

export async function setSentryUser(
  session: GetOutput<'dashboard-scope', 'read'> | undefined,
  user: GetOutput<'current-user', 'read'> | undefined,
) {
  const sentry = await getSentry();

  if (!sentry) {
    return;
  }

  if (typeof session === 'undefined' || typeof user === 'undefined') {
    sentry.getCurrentScope().setUser(null);
    sentry.setUser(null);
  } else {
    sentry.setUser({
      id: user.id,
    });
    sentry.setTags({
      account_id: session.account_id,
      default_site: session.default_site,
    });
  }
}

export async function setCurrentSiteTag(siteId: string | undefined) {
  const sentry = await getSentry();
  sentry.setTag('current_site', siteId);
}
